import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BankAccountsPage.BankingAppLoginPopup', {
    areYouSure: 'Are you sure you want to stop bank account connection?',
    authoriseTheConnection: 'Log in to your banking app and authorise the connection to ApprovalMax',
    connectSecurelyWith: 'Securely connect to {bank}',
    loginOnDesktop: 'Login on desktop',
    or: 'or',
    returnTo: 'Return to ApprovalMax to complete the setup',
    securelyLogin: 'Scan the QR code to use the mobile app or select log in via desktop.',
    yesStop: 'Yes, stop',
    byUsingYouAgree:
        'By using this service, you agree to Yapily Connect to access your bank data, subject to their {termsAndConditions} and {privacyNotice}.',
    termsAndConditions: 'Terms and Conditions',
    privacyNotice: 'Privacy Notice',
    youllBeRedirected: 'You will now be securely redirected to {bankName} to give access to the following information:',
    accountDetails: 'Account(s) details',
    balances: 'Balances',
    transactionHistory: 'Transaction history',
    weHavePartnered: 'We have partnered with Yapily Connect to access your bank data at {bankName}.',
});
